<template>
  <div>
    Sample was requested
  </div>
</template>

<script>
export default {
  components: {
  },
  props: {
  },
}
</script>
